import styled from '@emotion/styled';
import TableRow from '@mui/material/TableRow';
import { alpha } from '@mui/material/styles';

const HeaderRowTableFlexSales = styled(TableRow)`
  background: ${({ theme }) => theme.customTokens.surfaces.dataGridHeaderGradient};
  .MuiTableCell-head {
    color: ${({ theme }) => theme.palette.text.primary};
    font-weight: ${({ theme }) => theme.typography.subtitle2.fontWeight};
    background-color: ${({ theme }) => alpha(theme.palette.background.paper, 0.86)};
    backdrop-filter: blur(8px);
  }
`;

export default HeaderRowTableFlexSales;
